module.exports = __webpack_public_path__ + "img/left2.96274953.jpg";